import { Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output, inject, DestroyRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import * as _ from 'lodash-es';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import { JsonObjectFactoryService } from '../../../global/services/json-object-factory.service';
import { AttributeBatchService } from './attribute-batch.service';
import {
  buildHeaderDataShell,
  normalizeFilterParams,
  gridPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';
import { AppkitDropdownItem } from '../../../shared/utils/appkit-dropdown.util';
import {
  handleNamedDropdownSelect,
  refreshNamedDropdown,
  setFormDropdownAriaLabel
} from '../../shared/ftc-form-dropdown.support';

@Component({
    selector: 'gtw-attribute-batch',
    templateUrl: './attribute-batch.component.html',
    styleUrls: ['./attribute-batch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AttributeBatchComponent implements OnInit, OnDestroy {
  setFormDropdownAriaLabel = setFormDropdownAriaLabel;
  attributeDataView: AppkitDropdownItem[] = [];
  countryCodeDataView: AppkitDropdownItem[] = [];
  sicCodeDataView: AppkitDropdownItem[] = [];
  baseBasketDataAttributeInfoView: AppkitDropdownItem[] = [];
  baseFdiiDataAttributeInfoView: AppkitDropdownItem[] = [];
  yesNoDataView: AppkitDropdownItem[] = [];
  beatTypeDataView: AppkitDropdownItem[] = [];
  methodCodeDataView: AppkitDropdownItem[] = [];
  baseLevelDataView: AppkitDropdownItem[] = [];
  baseEntityDataView: AppkitDropdownItem[] = [];
  baseFDIIDataView: AppkitDropdownItem[] = [];
  baseBasketDataView: AppkitDropdownItem[] = [];
  basketCodeAllocateDataView: AppkitDropdownItem[] = [];
  selectedAttributesItem: AppkitDropdownItem | null = null;
  selectedCountryCodeItem: AppkitDropdownItem | null = null;
  selectedSICCOdeItem: AppkitDropdownItem | null = null;
  selectedBasketInfoByAttrItem: AppkitDropdownItem | null = null;
  selectedBaseFdiiInfoByAttrItem: AppkitDropdownItem | null = null;
  selectedBeatCodeItem: AppkitDropdownItem | null = null;
  selectedBeatTypeCodeItem: AppkitDropdownItem | null = null;
  selectedMethodCodeItem: AppkitDropdownItem | null = null;
  selectedBaseLevelCodeItem: AppkitDropdownItem | null = null;
  selectedBaseEntityLevelCodeItem: AppkitDropdownItem | null = null;
  selectedBaseFdiiCodesItem: AppkitDropdownItem | null = null;
  selectedBaseBasketCodeItem: AppkitDropdownItem | null = null;

  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  private readonly subs = new Subscription();
  private isInitialized = false;
  GENERAL_CONFIG: any = {};
  private globalParams: any = {};
  filterParams: any = {};
  private userSettings: any = {};

  minimise = false;
  isSaveClicked = false;
  crudLoading = false;
  loadingData = true;
  disableBaseLevel = false;

  logged_in_user = '';
  curentyear = '';
  scenario = '';
  jcd_key: any;
  QARScenario = 'N';
  gie_key: any;

  gridDataMultipleSelect: any[] = [];
  is_locked: any = null;

  attributeData: any[] = [
    { CODE_KEY: 'METHOD & BASE', CODE_DESCRIPTION: 'METHOD & BASE' },
    { CODE_KEY: 'SIC_CODE', CODE_DESCRIPTION: 'SIC CODE' },
    { CODE_KEY: 'BASKET', CODE_DESCRIPTION: 'BASKET' },
    { CODE_KEY: 'FDII_CODE', CODE_DESCRIPTION: 'FDII' },
    { CODE_KEY: 'BEAT_CODE', CODE_DESCRIPTION: 'BEAT' },
    { CODE_KEY: 'COUNTRY_CODE', CODE_DESCRIPTION: 'COUNTRY' },
  ];

  selectedAttributes: any = '';
  selectedMethodCode: any = '';
  selectedBaseFdiiCodes: any[] = [];
  selectedBaseBasketCode: any[] = [];
  selectedBaseTypeCode: any[] = [];
  selectedBaseLevelCode: any = [];
  selectedBaseEntityLevelCode: any = [];
  selectedSICCOde: any;
  selectedCountryCode: any;
  selectedBasketInfoByAttr: any;
  selectedBaseFdiiInfoByAttr: any;
  selectedBeatCode: any;
  selectedBeatTypeCode: any = '';
  selectedBeatWithhold: any = '';

  baseFDIIData: any[] = [];
  baseBasketData: any[] = [];
  basketCodeAllocateData: any[] = [];
  baseLevelData: any[] = [];
  baseEntityData: any[] = [];
  baseBasketTypeData: any[] = [];
  basefdiiSingleMultiData: any[] = [];
  baseTypeCodeData: any[] = [];
  sicCodeData: any[] = [];
  countryCodeData: any[] = [];
  methodCodeData: any[] = [];
  allTransCategoryData: any[] = [];
  allGPTransCategoryData: any[] = [];
  baseTypeData: any[] = [];
  dropdownLists: { [k: string]: any[] } = { baseFDII: [], baseBasket: [], baseType: [] };
  attribMastData: any[] = [];
  baseBasketDataAttributeInfo: any[] = [];
  baseFdiiDataAttributeInfo: any[] = [];
  yesNoData: any[] = [];
  beatTypeData: any[] = [];

  displaySingleSelectBase = '';
  gIncomeMethodFlag = '';
  intExpHideBaseFields = 'false';
  selectedGieName = '';
  isLockedWarningExists = false;
  isLockedWarningMsgs: string | null = null;
  counter = { ghost: 0, drd: 0 };

  private previousMethodCode: any = null;

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService,
    private jsonObjectFactory: JsonObjectFactoryService,
    private attributeBatchService: AttributeBatchService,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.tryInit();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    this.isInitialized = false;
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalParams = header.globalParams || {};
    this.userSettings = header.userSettingsData || {};
    this.filterParams = normalizeFilterParams(activeScreen);

    const gridPayload = gridPayloadFromActiveScreen(activeScreen);
    if (gridPayload) {
      this.gridDataMultipleSelect = _.clone(Array.isArray(gridPayload) ? gridPayload : []);
    }
  }

  private tryInit(): void {
    if (this.isInitialized) return;
    if (!this.GENERAL_CONFIG?.base_url) return;
    this.isInitialized = true;

    this.logged_in_user = this.userSettings?.user?.sso_id || this.userSettings?.sso_id || '';
    this.curentyear = this.filterParams.tax_year;
    this.scenario = this.filterParams.scenario;
    this.jcd_key = this.globalParams.jcd_key;

    this.checkLockStatus();
    this.processGridData();
    this.getCodeMastData();
    this.getAttribMast();
  }

  private checkLockStatus(): void {
    const lockparams = {
      action_code: 'n10cpv',
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', lockparams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.jsonObject) {
        const lockData = data.jsonObject;
        if (lockData?.[0]?.LOCK_STATUS === 'Y') {
          this.cancel();
          this.gtwSnackbar.openSnackBar('Tax Return has already been filed for tax year ' + this.curentyear + '.', 'gtw-snackbar--red', true, 4);
          return;
        }
        if (lockData?.[0]?.SCENARIO_DESC === 'EXAM') {
          this.QARScenario = 'Y';
        }
      }
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  private processGridData(): void {
    console.log('[AttributeBatch] processGridData called, gridDataMultipleSelect:', this.gridDataMultipleSelect);

    if (!this.gridDataMultipleSelect || this.gridDataMultipleSelect.length === 0) {
      console.warn('[AttributeBatch] gridDataMultipleSelect is empty or null — returning early');
      return;
    }

    const firstRow = this.gridDataMultipleSelect[0]?.data;
    console.log('[AttributeBatch] firstRow:', firstRow);

    if (!firstRow) {
      console.warn('[AttributeBatch] firstRow is falsy (item has no .data property) — returning early');
      return;
    }

    const grossIncExp = firstRow.GROSS_INC_EXP;
    console.log('[AttributeBatch] GROSS_INC_EXP =', grossIncExp);

    this.attributeData = [
      { CODE_KEY: 'METHOD & BASE', CODE_DESCRIPTION: 'METHOD & BASE' },
      { CODE_KEY: 'SIC_CODE', CODE_DESCRIPTION: 'SIC CODE' },
      { CODE_KEY: 'BASKET', CODE_DESCRIPTION: 'BASKET' },
      { CODE_KEY: 'FDII_CODE', CODE_DESCRIPTION: 'FDII' },
      { CODE_KEY: 'BEAT_CODE', CODE_DESCRIPTION: 'BEAT' },
      { CODE_KEY: 'COUNTRY_CODE', CODE_DESCRIPTION: 'COUNTRY' },
    ];

    if (grossIncExp == 'ASTEXP') {
      this.attributeData = [{ CODE_KEY: 'METHOD & BASE', CODE_DESCRIPTION: 'METHOD & BASE' }];
      console.log('[AttributeBatch] ASTEXP detected — attributeData narrowed to METHOD & BASE only');
    }

    console.log('[AttributeBatch] final attributeData:', this.attributeData);

    this.isLockedWarningExists = false;
    this.isLockedWarningMsgs = null;
    for (const item of this.gridDataMultipleSelect) {
      if (item?.data?.STATUS_FLAG == 'Locked') {
        this.isLockedWarningExists = true;
      }
    }
    if (this.isLockedWarningExists) {
      this.isLockedWarningMsgs = 'Cannot update the Locked Tag';
    }
    this.cdr.detectChanges();
  }

  removeAttribBatchUpdateRow(rowData: any): void {
    const index = this.gridDataMultipleSelect.indexOf(rowData);
    if (index > -1) {
      this.gridDataMultipleSelect.splice(index, 1);
    }

    this.isLockedWarningExists = false;
    this.isLockedWarningMsgs = null;
    for (const item of this.gridDataMultipleSelect) {
      if (item?.data?.STATUS_FLAG == 'Locked') {
        this.isLockedWarningExists = true;
      }
    }
    if (this.isLockedWarningExists) {
      this.isLockedWarningMsgs = 'Cannot update the Locked Tag';
    }
    this.changeAttribute();
        this.refreshFormDropdowns();
    this.cdr.detectChanges();
  }

  getCodeMastData(onChangeCheck?: boolean): void {
    const params = {
      action_code: '31hizx',
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      const jsonObj = data?.jsonObject || [];

      this.baseFDIIData = _.filter(jsonObj, (p: any) => _.includes(['FDII_CODE'], p.CODE_GROUP));
      this.baseBasketData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
      _.remove(this.baseBasketData, { CODE_DESCRIPTION: 'Default' });
      this.syncDropdownList('baseFDII', this.baseFDIIData);
      this.syncDropdownList('baseBasket', this.baseBasketData);
      this.basketCodeAllocateData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE_ALLOCATE'], p.CODE_GROUP));
      _.remove(this.basketCodeAllocateData, { CODE_DESCRIPTION: 'Default' });
      this.baseLevelData = _.filter(jsonObj, (p: any) => _.includes(['BASE_LEVEL_CODE'], p.CODE_GROUP));
      this.baseEntityData = _.filter(jsonObj, (p: any) => _.includes(['BASE_ENTITY_CODE'], p.CODE_GROUP));
      this.baseBasketTypeData = _.filter(jsonObj, (p: any) => _.includes(['BASE_BASKET_CODE'], p.CODE_GROUP));
      this.basefdiiSingleMultiData = _.filter(jsonObj, (p: any) => _.includes(['BASE_FDII_CODE'], p.CODE_GROUP));
      this.baseTypeCodeData = _.filter(jsonObj, (p: any) => _.includes(['BASE_TYPE_CODE'], p.CODE_GROUP));
      this.sicCodeData = _.filter(jsonObj, (p: any) => _.includes(['SIC_CODE'], p.CODE_GROUP));
      this.countryCodeData = _.filter(jsonObj, (p: any) => _.includes(['COUNTRY_CODE'], p.CODE_GROUP));
      this.yesNoData = _.filter(jsonObj, (p: any) => _.includes(['YES_NO'], p.CODE_GROUP));
      this.beatTypeData = _.filter(jsonObj, (p: any) => _.includes(['BEAT_TYPE_CODE'], p.CODE_GROUP));

      this.counter.ghost = _.filter(this.gridDataMultipleSelect, (p: any) => p?.data?.MODULE_NAME == 'GHOST').length;
      this.counter.drd = _.filter(this.gridDataMultipleSelect, (p: any) => p?.data?.MODULE_NAME == 'DRD').length;

      if (this.gridDataMultipleSelect.length == this.counter.ghost ||
          this.gridDataMultipleSelect.length == this.counter.drd ||
          this.gridDataMultipleSelect.length == this.counter.drd + this.counter.ghost) {
        this.baseBasketDataAttributeInfo = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE_ALLOCATE'], p.CODE_GROUP));
      } else {
        this.baseBasketDataAttributeInfo = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
      }
      this.baseFdiiDataAttributeInfo = _.filter(jsonObj, (p: any) => _.includes(['FDII_CODE'], p.CODE_GROUP));

      if (onChangeCheck !== false) {
        this.getMethod();
      }
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  getMethod(): void {
    if (!this.gridDataMultipleSelect || this.gridDataMultipleSelect.length === 0) return;
    this.gie_key = this.gridDataMultipleSelect[0]?.data?.GIE_KEY;
    const params = {
      action_code: 'lwtsx1',
      gie_key: this.gie_key,
      p_scenario: this.scenario,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.methodCodeData = data?.jsonObject || [];
      this.getAllTransCatgExceptExp();

      const firstGross = this.gridDataMultipleSelect[0]?.data?.GROSS_INC_EXP;
      if ((firstGross == 'EXPAA' || firstGross == 'ASTEXP' ||
           firstGross == 'INTEXP' || firstGross == 'INVESTMENTS') && this.QARScenario == 'Y') {
        for (let i = this.methodCodeData.length - 1; i >= 0; i--) {
          if (this.methodCodeData[i].CODE_DESCRIPTION != 'Allocate') {
            this.methodCodeData.splice(i, 1);
          }
        }
      }
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  getAllTransCatgExceptExp(): void {
    const params = {
      action_code: '9aszao',
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.allTransCategoryData = data?.jsonObject || [];
      this.allGPTransCategoryData = _.filter(this.allTransCategoryData, (p: any) => _.includes(['GPROFIT'], p.GIE_NAME));

      if (this.selectedGieName == 'EXPAA' || this.selectedGieName == 'ASTEXP' || this.selectedGieName == 'INVESTMENTS') {
        if (this.selectedMethodCode && this.selectedMethodCode.CODE_DESCRIPTION != 'Allocate' && this.selectedMethodCode.CODE_DESCRIPTION != 'Gross Income') {
          this.baseTypeData = this.allGPTransCategoryData;
        } else if (this.selectedMethodCode && this.selectedMethodCode.CODE_DESCRIPTION == 'Gross Income') {
          this.baseTypeData = this.allTransCategoryData;
        }
      } else {
        this.baseTypeData = this.allGPTransCategoryData;
      }
      this.syncDropdownList('baseType', this.baseTypeData);
      this.cdr.detectChanges();
    });
  }

  getAttribMast(): void {
    const params = { action_code: '2nk5nz' };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.attribMastData = data?.jsonObject || [];
      this.cdr.detectChanges();
    });
  }

  changeSelectedBeatWithHold(): void {
    if (this.selectedBeatWithhold && (this.selectedBeatWithhold < 0 || this.selectedBeatWithhold > 100)) {
      this.gtwSnackbar.openSnackBar('Please select BEAT Withhold between 0 to 100 only', 'gtw-snackbar--red', true, 5);
      this.isSaveClicked = true;
    } else {
      this.isSaveClicked = false;
    }
  }

  changeAttribute(): void {
    const expectedGrossIncExp = ['EXPAA', 'ASTEXP', 'INVESTMENTS', 'INTEXP', 'RESEARCH', 'GPROFIT', 'Prorate Variance'];
    let filterInfo: any[];
    let isErrorChangeSelection = false;
    const specificType = this.gridDataMultipleSelect?.[0]?.data?.GROSS_INC_EXP;

    if (this.selectedAttributes?.CODE_DESCRIPTION === 'METHOD & BASE') {
      const combinationFilterCheck = _.filter(this.gridDataMultipleSelect, (o: any) =>
        _.includes(specificType, o?.data?.GROSS_INC_EXP)
      );
      filterInfo = _.filter(this.gridDataMultipleSelect, (o: any) =>
        _.includes(expectedGrossIncExp, o?.data?.GROSS_INC_EXP)
      );

      let combinationFilterCheckGP: any[] | undefined;
      if (specificType === 'GPROFIT') {
        combinationFilterCheckGP = _.filter(this.gridDataMultipleSelect, (o: any) =>
          _.includes(specificType, o?.data?.GROSS_INC_EXP) && _.includes('Prorate Variance', o?.data?.TRANS_CATG_NAME)
        );
      }

      if (filterInfo.length !== this.gridDataMultipleSelect.length) {
        this.gtwSnackbar.openSnackBar('You can not select Income or Gross Profit Non Prorate Tags', 'gtw-snackbar--red', true, 4);
        isErrorChangeSelection = true;
      } else if (combinationFilterCheck.length !== this.gridDataMultipleSelect.length) {
        this.gtwSnackbar.openSnackBar('Select only GP Prorate Tags or Expense A&A', 'gtw-snackbar--red', true, 4);
        isErrorChangeSelection = true;
      } else if (combinationFilterCheckGP && combinationFilterCheckGP.length !== this.gridDataMultipleSelect.length) {
        this.gtwSnackbar.openSnackBar('Select only GP Prorate Tags', 'gtw-snackbar--red', true, 4);
        isErrorChangeSelection = true;
      }

      this.isSaveClicked = isErrorChangeSelection;
      this.getMethod();
    }

    if (this.selectedAttributes?.CODE_DESCRIPTION === 'SIC CODE') {
      filterInfo = _.filter(this.gridDataMultipleSelect, (o: any) =>
        o?.data?.GIE_TYPE == 'INC' || o?.data?.GROSS_INC_EXP === 'RESEARCH' ||
        (o?.data?.GIE_TYPE == 'GP' && o?.data?.TRANS_CATG_NAME !== 'Prorate Variance')
      );
      if (filterInfo.length !== this.gridDataMultipleSelect.length) {
        this.gtwSnackbar.openSnackBar('You can select Income, Research or Gross Profit Non Prorate Tags', 'gtw-snackbar--red', true, 4);
        this.isSaveClicked = true;
      } else {
        this.isSaveClicked = false;
      }
    }

    if (this.selectedAttributes?.CODE_DESCRIPTION === 'BASKET' || this.selectedAttributes?.CODE_DESCRIPTION === 'FDII') {
      filterInfo = _.filter(this.gridDataMultipleSelect, (o: any) =>
        o?.data?.GIE_TYPE == 'INC' || (o?.data?.GIE_TYPE == 'GP' && o?.data?.TRANS_CATG_NAME !== 'Prorate Variance')
      );
      if (filterInfo.length !== this.gridDataMultipleSelect.length) {
        this.gtwSnackbar.openSnackBar('You can select Income or Gross Profit Non Prorate Tags', 'gtw-snackbar--red', true, 4);
        this.isSaveClicked = true;
      } else {
        this.isSaveClicked = false;
      }
    }

    if (this.selectedAttributes?.CODE_DESCRIPTION === 'BEAT') {
      filterInfo = _.filter(this.gridDataMultipleSelect, (o: any) =>
        o?.data?.GIE_TYPE === 'OTH_EXP' || o?.data?.GIE_TYPE === 'EXP'
      );
      if (filterInfo.length !== this.gridDataMultipleSelect.length) {
        this.gtwSnackbar.openSnackBar('BEAT is applicable only for Expense Tags', 'gtw-snackbar--red', true, 4);
        this.isSaveClicked = true;
      } else {
        this.isSaveClicked = false;
      }
    }
        this.refreshFormDropdowns();
    this.cdr.detectChanges();
  }

  changeMethod(): void {
    this.displaySingleSelectBase = '';
    this.gIncomeMethodFlag = '';
    this.intExpHideBaseFields = 'false';

    const firstRow = this.gridDataMultipleSelect?.[0]?.data;
    if (firstRow?.GIE_SHORT_DESC === 'Gross Profit' && firstRow?.TRANS_CATG_NAME === 'Prorate Variance') {
      const exists = _.find(this.baseLevelData, ['CODE_SHORT_DESC', 'ME']);
      this.selectedBaseLevelCode = exists ? exists.CODE_KEY : [];
      const existNew = _.find(this.baseEntityData, ['CODE_SHORT_DESC', 'COMPONENT']);
      this.selectedBaseEntityLevelCode = existNew ? existNew.CODE_KEY : [];
      this.disableBaseLevel = true;
    } else {
      this.disableBaseLevel = false;
      this.selectedBaseLevelCode = [];
      this.selectedBaseEntityLevelCode = [];
    }

    if (firstRow) {
      this.selectedGieName = firstRow.GROSS_INC_EXP;
    }

    if (this.selectedGieName == 'EXPAA' || this.selectedGieName == 'ASTEXP' || this.selectedGieName == 'INVESTMENTS') {
      if (this.selectedMethodCode?.CODE_DESCRIPTION != 'Allocate' && this.selectedMethodCode?.CODE_DESCRIPTION != 'Gross Income') {
        this.gIncomeMethodFlag = 'false';
        this.baseTypeData = this.allGPTransCategoryData;
        this.syncDropdownList('baseType', this.baseTypeData);
      } else if (this.selectedMethodCode?.CODE_DESCRIPTION == 'Allocate') {
        this.displaySingleSelectBase = 'true';
        _.remove(this.selectedBaseFdiiCodes, undefined);
        _.remove(this.selectedBaseBasketCode, undefined);
      } else if (this.selectedMethodCode?.CODE_DESCRIPTION == 'Gross Income') {
        this.gIncomeMethodFlag = 'true';
        this.baseTypeData = this.allTransCategoryData;
        this.syncDropdownList('baseType', this.baseTypeData);
      }
    }

    if (this.selectedGieName == 'INTEXP' || this.selectedGieName == 'RESEARCH') {
      if (this.selectedMethodCode?.CODE_DESCRIPTION == 'Allocate') {
        this.displaySingleSelectBase = 'true';
        _.remove(this.selectedBaseFdiiCodes, undefined);
        _.remove(this.selectedBaseBasketCode, undefined);
      } else if (this.selectedMethodCode?.CODE_DESCRIPTION == 'Interest Expense' || this.selectedMethodCode?.CODE_DESCRIPTION == 'Research Expense') {
        this.intExpHideBaseFields = 'true';
      }
    }
    this.cdr.detectChanges();
  }

  onMethodChange(): void {
    if (this.selectedMethodCode === this.previousMethodCode) return;
    this.previousMethodCode = this.selectedMethodCode;

    this.selectedBaseFdiiCodes = [];
    this.selectedBaseBasketCode = [];
    this.selectedBaseTypeCode = [];
    this.selectedBaseLevelCode = [];
    this.selectedBaseEntityLevelCode = [];
    this.getCodeMastData(false);
    this.getAllTransCatgExceptExp();

    const firstRow = this.gridDataMultipleSelect?.[0]?.data;
    if (firstRow?.GIE_SHORT_DESC === 'Gross Profit' && firstRow?.TRANS_CATG_NAME === 'Prorate Variance') {
      const exists = _.find(this.baseLevelData, ['CODE_SHORT_DESC', 'ME']);
      this.selectedBaseLevelCode = exists ? exists.CODE_KEY : [];
      const existNew = _.find(this.baseEntityData, ['CODE_SHORT_DESC', 'COMPONENT']);
      this.selectedBaseEntityLevelCode = existNew ? existNew.CODE_KEY : [];
      this.disableBaseLevel = true;
    } else {
      this.disableBaseLevel = false;
      this.selectedBaseLevelCode = [];
      this.selectedBaseEntityLevelCode = [];
    }
    this.changeMethod();
  }

  resetBatch(): void {
    this.selectedAttributes = '';
    this.selectedBeatTypeCode = '';
    this.selectedBeatWithhold = '';
    this.selectedMethodCode = '';
    this.selectedBaseFdiiCodes = [];
    this.selectedBaseBasketCode = [];
    this.selectedBaseTypeCode = [];
    this.selectedBaseLevelCode = [];
    this.selectedBaseEntityLevelCode = [];
    this.getCodeMastData();
        this.refreshFormDropdowns();
    this.cdr.detectChanges();
  }

  compareItems(a: any, b: any): boolean {
    return a && b && a.CODE_KEY == b.CODE_KEY;
  }

  save(): void {
    this.isSaveClicked = true;

    if (!this.validateBeforeSave()) return;

    const returnObj: any = {};
    this.buildReturnObj(returnObj);

    const attribManagementBatchUpdateDetails: any[] = [];
    for (const item of this.gridDataMultipleSelect) {
      const returnObjLoop = _.cloneDeep(returnObj);
      returnObjLoop.COMBINATION_KEY = item.data.COMBINATION_KEY;
      returnObjLoop.TAG_KEY = item.data.TAG_KEY;
      returnObjLoop.GIE_KEY = item.data.GIE_KEY;
      returnObjLoop.OPERATION_TYPE = 'BU';
      attribManagementBatchUpdateDetails.push(returnObjLoop);
    }

    const returnClobSettingsObj: any = {
      sso_id: this.logged_in_user,
      screen_key: this.globalParams.screen_key,
      p_tax_year: this.curentyear,
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };

    this.attributeBatchService.saveDefaults(
      this.GENERAL_CONFIG.base_url,
      this.globalParams,
      this.filterParams,
      returnClobSettingsObj,
      attribManagementBatchUpdateDetails
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result: any) => {
      if (result?.errorMessage && result.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(result.errorMessage, 'gtw-snackbar--red', true, 4);
      } else if (result?.data?.errorMessage && result.data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(result.data.errorMessage, 'gtw-snackbar--red', true, 4);
      } else {
        this.gtwSnackbar.openSnackBar('Tag has been successfully saved/updated', 'gtw-snackbar--green', true, 4);
        this.requestGridUpdate.emit('refresh');
      }
      this.cdr.detectChanges();
    });
  }

  private validateBeforeSave(): boolean {
    if (this.selectedAttributes?.CODE_DESCRIPTION === 'METHOD & BASE' && this.selectedMethodCode?.CODE_DESCRIPTION == 'Allocate') {
      if (!this.selectedMethodCode || !this.selectedBaseFdiiCodes || !this.selectedBaseBasketCode) {
        this.isSaveClicked = false;
        this.gtwSnackbar.openSnackBar('Please select all the attributes', 'gtw-snackbar--red', true, 4);
        return false;
      }
      _.remove(this.selectedBaseTypeCode, undefined);
    } else if (this.selectedAttributes?.CODE_DESCRIPTION === 'METHOD & BASE') {
      if (!this.selectedMethodCode || (this.selectedMethodCode.CODE_DESCRIPTION != 'Interest Expense' && this.selectedMethodCode.CODE_DESCRIPTION != 'Research Expense')) {
        if (!this.selectedMethodCode ||
            !this.selectedBaseFdiiCodes || this.selectedBaseFdiiCodes.length == 0 ||
            !this.selectedBaseBasketCode || this.selectedBaseBasketCode.length == 0 ||
            !this.selectedBaseTypeCode || this.selectedBaseTypeCode.length == 0 ||
            !this.selectedBaseLevelCode || (Array.isArray(this.selectedBaseLevelCode) && this.selectedBaseLevelCode.length == 0) ||
            !this.selectedBaseEntityLevelCode || (Array.isArray(this.selectedBaseEntityLevelCode) && this.selectedBaseEntityLevelCode.length == 0)) {
          this.isSaveClicked = false;
          this.gtwSnackbar.openSnackBar('Please select all the attributes', 'gtw-snackbar--red', true, 4);
          return false;
        }
      }
    }

    if (this.selectedAttributes?.CODE_DESCRIPTION === 'SIC CODE' && !this.selectedSICCOde) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select SIC Code', 'gtw-snackbar--red', true, 4);
      return false;
    }

    if (this.selectedAttributes?.CODE_KEY === 'COUNTRY_CODE' && !this.selectedCountryCode) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Country Code', 'gtw-snackbar--red', true, 4);
      return false;
    }

    if (this.selectedAttributes?.CODE_DESCRIPTION === 'BASKET' && !this.selectedBasketInfoByAttr) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Basket', 'gtw-snackbar--red', true, 4);
      return false;
    }

    if (this.selectedAttributes?.CODE_DESCRIPTION === 'FDII' && !this.selectedBaseFdiiInfoByAttr) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select FDII', 'gtw-snackbar--red', true, 4);
      return false;
    }

    if (this.selectedAttributes?.CODE_DESCRIPTION === 'BEAT') {
      if (!this.selectedBeatCode?.CODE_DESCRIPTION ||
          (this.selectedBeatCode.CODE_DESCRIPTION == 'Yes' &&
           (!this.selectedBeatTypeCode || this.selectedBeatTypeCode === '' ||
            this.selectedBeatWithhold === undefined || this.selectedBeatWithhold === null || this.selectedBeatWithhold === ''))) {
        this.isSaveClicked = false;
        this.gtwSnackbar.openSnackBar('Please select BEAT and its fields', 'gtw-snackbar--red', true, 4);
        return false;
      }

      if (this.selectedBeatCode.CODE_DESCRIPTION == 'Yes' || this.selectedBeatCode.CODE_DESCRIPTION == 'No') {
        const filterInfo = _.filter(this.gridDataMultipleSelect, (o: any) =>
          o?.data?.GIE_TYPE === 'OTH_EXP' || o?.data?.GIE_TYPE === 'EXP'
        );
        if (filterInfo.length !== this.gridDataMultipleSelect.length) {
          this.gtwSnackbar.openSnackBar('BEAT is applicable only for Expense Tags', 'gtw-snackbar--red', true, 4);
          this.isSaveClicked = false;
          return false;
        }
      }
    }

    return true;
  }

  private buildReturnObj(returnObj: any): void {
    let baseTypeSelected = '';
    for (const item of this.selectedBaseTypeCode) {
      if (item?.CODE_KEY != undefined) {
        baseTypeSelected += item.CODE_KEY + ',';
      }
    }
    if (baseTypeSelected) {
      returnObj.BASE_TYPE_DATA = baseTypeSelected.substring(0, baseTypeSelected.length - 1);
    }

    if (this.displaySingleSelectBase == 'true') {
      returnObj.BASE_FDII_DATA = this.selectedBaseFdiiCodes;
      const fdiiExists = _.find(this.basefdiiSingleMultiData, ['CODE_DESC', 'SINGLE']);
      if (fdiiExists) {
        const fdiiAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASE_FDII']);
        if (fdiiAttrib) returnObj[fdiiAttrib.ATTRIB_KEY + '_0'] = fdiiExists.CODE_KEY;
      }
      returnObj.BASE_BASKET_DATA = this.selectedBaseBasketCode;
      const basketExists = _.find(this.baseBasketTypeData, ['CODE_DESCRIPTION', 'SINGLE']);
      if (basketExists) {
        const basketAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASE_BASKET']);
        if (basketAttrib) returnObj[basketAttrib.ATTRIB_KEY + '_0'] = basketExists.CODE_KEY;
      }
    } else {
      if (this.intExpHideBaseFields == 'false') {
        let baseFdiiSelected = '';
        for (const item of this.selectedBaseFdiiCodes) {
          if (item?.CODE_KEY != undefined) {
            baseFdiiSelected += item.CODE_KEY + ',';
          }
        }
        returnObj.BASE_FDII_DATA = baseFdiiSelected ? baseFdiiSelected.substring(0, baseFdiiSelected.length - 1) : '';

        let baseBasketSelected = '';
        for (const item of this.selectedBaseBasketCode) {
          if (item?.CODE_KEY != undefined) {
            baseBasketSelected += item.CODE_KEY + ',';
          }
        }
        returnObj.BASE_BASKET_DATA = baseBasketSelected ? baseBasketSelected.substring(0, baseBasketSelected.length - 1) : '';

        this.setMultiSingleAllKey(returnObj, this.selectedBaseBasketCode, this.baseBasketData, this.baseBasketTypeData, 'BASE_BASKET');
        this.setMultiSingleAllKeyFdii(returnObj, this.selectedBaseFdiiCodes, this.baseFDIIData, this.basefdiiSingleMultiData, 'BASE_FDII');
      }
    }

    this.setMultiSingleAllKeyBaseType(returnObj, this.selectedBaseTypeCode, this.baseTypeData, this.baseTypeCodeData, 'BASE_TYPE');

    if (this.selectedMethodCode) {
      const methodAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'METHOD']);
      if (methodAttrib) returnObj[methodAttrib.ATTRIB_KEY + '_0'] = this.selectedMethodCode.CODE_KEY;
    }

    if (this.selectedBaseLevelCode != undefined && this.selectedMethodCode?.CODE_DESCRIPTION != 'Allocate' &&
        this.selectedMethodCode?.CODE_DESCRIPTION != 'Interest Expense' && this.selectedMethodCode?.CODE_DESCRIPTION != 'Research Expense') {
      const baseLevelAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASE_LEVEL']);
      if (baseLevelAttrib) returnObj[baseLevelAttrib.ATTRIB_KEY + '_0'] = this.selectedBaseLevelCode;
    }
    if (this.selectedBaseEntityLevelCode != undefined && this.selectedMethodCode?.CODE_DESCRIPTION != 'Allocate' &&
        this.selectedMethodCode?.CODE_DESCRIPTION != 'Interest Expense' && this.selectedMethodCode?.CODE_DESCRIPTION != 'Research Expense') {
      const baseEntityAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASE_ENTITY_LEVEL']);
      if (baseEntityAttrib) returnObj[baseEntityAttrib.ATTRIB_KEY + '_0'] = this.selectedBaseEntityLevelCode;
    }

    if (this.selectedMethodCode?.CODE_DESCRIPTION !== 'Allocate' && returnObj.BASE_FDII_DATA &&
        this.baseFDIIData && returnObj.BASE_FDII_DATA.split(',').length === this.baseFDIIData.length) {
      returnObj.BASE_FDII_DATA = '';
    }
    if (this.selectedMethodCode?.CODE_DESCRIPTION !== 'Allocate' && returnObj.BASE_BASKET_DATA &&
        this.baseBasketData && returnObj.BASE_BASKET_DATA.split(',').length === this.baseBasketData.length) {
      returnObj.BASE_BASKET_DATA = '';
    }
    if (this.selectedMethodCode?.CODE_DESCRIPTION !== 'Allocate' && returnObj.BASE_TYPE_DATA &&
        this.baseTypeData && returnObj.BASE_TYPE_DATA.split(',').length === this.baseTypeData.length) {
      returnObj.BASE_TYPE_DATA = '';
    }

    if (this.selectedAttributes?.CODE_DESCRIPTION === 'SIC CODE') {
      const sicAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'SIC_CODES']);
      if (sicAttrib) returnObj[sicAttrib.ATTRIB_KEY + '_0'] = this.selectedSICCOde?.CODE_KEY;
    }
    if (this.selectedAttributes?.CODE_KEY === 'COUNTRY_CODE') {
      const countryAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'COUNTRY']);
      if (countryAttrib) returnObj[countryAttrib.ATTRIB_KEY + '_0'] = this.selectedCountryCode?.CODE_KEY;
    }
    if (this.selectedAttributes?.CODE_DESCRIPTION === 'BASKET') {
      const basketAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASKET']);
      if (basketAttrib) returnObj[basketAttrib.ATTRIB_KEY + '_0'] = this.selectedBasketInfoByAttr?.CODE_KEY;
    }
    if (this.selectedAttributes?.CODE_DESCRIPTION === 'FDII') {
      const fdiiAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'FDII']);
      if (fdiiAttrib) returnObj[fdiiAttrib.ATTRIB_KEY + '_0'] = this.selectedBaseFdiiInfoByAttr?.CODE_KEY;
    }
    if (this.selectedAttributes?.CODE_DESCRIPTION === 'BEAT') {
      const beatAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BEAT']);
      if (beatAttrib) returnObj[beatAttrib.ATTRIB_KEY + '_0'] = this.selectedBeatCode?.CODE_KEY;
      if (this.selectedBeatCode?.CODE_DESCRIPTION === 'Yes') {
        const beatTypeAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BEAT_TYPE']);
        if (beatTypeAttrib) returnObj[beatTypeAttrib.ATTRIB_KEY + '_0'] = this.selectedBeatTypeCode;
        const beatWithholdAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BEAT_WITHHOLD']);
        if (beatWithholdAttrib) returnObj[beatWithholdAttrib.ATTRIB_KEY + '_0'] = this.selectedBeatWithhold;
      } else {
        const beatTypeAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BEAT_TYPE']);
        if (beatTypeAttrib) returnObj[beatTypeAttrib.ATTRIB_KEY + '_0'] = '';
        const beatWithholdAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BEAT_WITHHOLD']);
        if (beatWithholdAttrib) returnObj[beatWithholdAttrib.ATTRIB_KEY + '_0'] = '';
      }
    }
  }

  private setMultiSingleAllKey(returnObj: any, selected: any[], allData: any[], typeData: any[], attribName: string): void {
    const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', attribName]);
    if (!attrib) return;
    if (selected?.length == 1) {
      const exists = _.find(typeData, ['CODE_DESCRIPTION', 'SINGLE']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    } else if (selected && allData && selected.length === allData.length) {
      const exists = _.find(typeData, ['CODE_DESCRIPTION', 'ALL']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    } else if (selected?.length > 1) {
      const exists = _.find(typeData, ['CODE_DESCRIPTION', 'MULTI']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    }
  }

  private setMultiSingleAllKeyFdii(returnObj: any, selected: any[], allData: any[], typeData: any[], attribName: string): void {
    const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', attribName]);
    if (!attrib) return;
    if (selected?.length == 1) {
      const exists = _.find(typeData, ['CODE_DESC', 'SINGLE']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    } else if (selected && allData && selected.length === allData.length) {
      const exists = _.find(typeData, ['CODE_DESC', 'ALL']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    } else if (selected?.length > 1) {
      const exists = _.find(typeData, ['CODE_DESC', 'MULTI']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    }
  }

  private setMultiSingleAllKeyBaseType(returnObj: any, selected: any[], allData: any[], typeData: any[], attribName: string): void {
    const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', attribName]);
    if (!attrib) return;
    if (selected?.length == 1) {
      const exists = _.find(typeData, ['CODE_DESCRIPTION', 'SINGLE']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    } else if (selected && allData && selected.length === allData.length) {
      const exists = _.find(typeData, ['CODE_DESCRIPTION', 'ALL']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    } else if (selected?.length > 1) {
      const exists = _.find(typeData, ['CODE_DESCRIPTION', 'MULTI']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    }
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }

  onDropdownFilterResult(key: string, event: any): void {
    this.dropdownLists[key] = event?.result || [];
  }

  private toAppkitOptions(items: any[]): any[] {
    return (items || []).map((item: any) => {
      item.showCheckbox = true;
      item.role = 'checkbox';
      return item;
    });
  }

  private syncDropdownList(key: string, master: any[]): void {
    this.dropdownLists[key] = this.toAppkitOptions(master).slice();
  }
  private refreshFormDropdowns(): void {
    refreshNamedDropdown(this, 'attributeData', 'selectedAttributes', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'countryCodeData', 'selectedCountryCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'sicCodeData', 'selectedSICCOde', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'baseBasketDataAttributeInfo', 'selectedBasketInfoByAttr', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'baseFdiiDataAttributeInfo', 'selectedBaseFdiiInfoByAttr', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'yesNoData', 'selectedBeatCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'beatTypeData', 'selectedBeatTypeCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'methodCodeData', 'selectedMethodCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'baseLevelData', 'selectedBaseLevelCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'baseEntityData', 'selectedBaseEntityLevelCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'baseFDIIData', 'selectedBaseFdiiCodes', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'baseBasketData', 'selectedBaseBasketCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'basketCodeAllocateData', 'selectedBaseBasketCode', 'CODE_DESCRIPTION', 'CODE_KEY');
  }

  onChangeAttributeFromDropdown(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedAttributesItem', 'selectedAttributes', 'CODE_DESCRIPTION', 'CODE_KEY', 'attributeDataView', () => this.changeAttribute());
  }
  onSelectedCountryCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedCountryCodeItem', 'selectedCountryCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'countryCodeDataView');
  }
  onSelectedSICCOdeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedSICCOdeItem', 'selectedSICCOde', 'CODE_DESCRIPTION', 'CODE_KEY', 'sicCodeDataView');
  }
  onSelectedBasketInfoByAttrSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBasketInfoByAttrItem', 'selectedBasketInfoByAttr', 'CODE_DESCRIPTION', 'CODE_KEY', 'baseBasketDataAttributeInfoView');
  }
  onSelectedBaseFdiiInfoByAttrSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBaseFdiiInfoByAttrItem', 'selectedBaseFdiiInfoByAttr', 'CODE_DESCRIPTION', 'CODE_KEY', 'baseFdiiDataAttributeInfoView');
  }
  onSelectedBeatCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBeatCodeItem', 'selectedBeatCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'yesNoDataView');
  }
  onSelectedBeatTypeCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBeatTypeCodeItem', 'selectedBeatTypeCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'beatTypeDataView');
  }
  onOnMethodChangeFromDropdown(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedMethodCodeItem', 'selectedMethodCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'methodCodeDataView', () => this.onMethodChange());
  }
  onSelectedBaseLevelCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBaseLevelCodeItem', 'selectedBaseLevelCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'baseLevelDataView');
  }
  onSelectedBaseEntityLevelCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBaseEntityLevelCodeItem', 'selectedBaseEntityLevelCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'baseEntityDataView');
  }
  onSelectedBaseFdiiCodesSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBaseFdiiCodesItem', 'selectedBaseFdiiCodes', 'CODE_DESCRIPTION', 'CODE_KEY', 'baseFDIIDataView');
  }
  onSelectedBaseBasketCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBaseBasketCodeItem', 'selectedBaseBasketCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'basketCodeAllocateDataView');
  }

  onDropdownSelectItem(_event: any): void {}

}
